import { AdsStudioAppNameODataHeader } from '../constants';

//
export const getODataConfig = (serverContext) => {
  // todo: [4183527] move this odataPath value to serverContext and remove dup code from app init
  const isLocal = () => {
    const hostname = document.location.hostname.toLowerCase();
    return hostname.indexOf('ads.microsoft.com') === -1 &&
        hostname.indexOf('ads-int.microsoft.com') === -1;
  };

  const odataPath = isLocal() ? 'Advertiser/V2' : 'Campaign/V2';

  const oDataConfig = {
    odataToken: serverContext.Token,
    oDataToken: serverContext.Token,
    odataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
    oDataPath: `${serverContext.ServicesEndpoints.CampaignAPI}${odataPath}`,
    applicationName: AdsStudioAppNameODataHeader.value,
    beforeSend: xhr => ({
      onBeforeSendDone: () => {
        xhr.setRequestHeader(AdsStudioAppNameODataHeader.key, AdsStudioAppNameODataHeader.value);
      },
    }),
  };
  return oDataConfig;
};
